/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const signUpBodyPasswordMin = 12;

export const SignUpBody = zod
	.object({
		identifier: zod.string().describe('Email address or phone number'),
		password: zod.string().min(signUpBodyPasswordMin).describe('Password')
	})
	.describe('Sign up request body');

export type SignUpBody = zod.input<typeof SignUpBody>;
export type SignUpBodyOutput = zod.output<typeof SignUpBody>;
